export { default } from "./CopyAssignmentLink";
